import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CandidatureFormation} from '../candidature-formation.model';
import {CONSTANTS} from '../../../cadens.constants';
import {CategorieFormation, CategorieFormationService, Question, QuestionService} from '../../formation';
import {Reponse} from './reponse.model';
import {Observable} from 'rxjs';
import {ReponseService} from './reponse.service';
import {UserEnEchange, UserEnEchangeService} from '../../user-en-echange';
import {FormationComponentService} from './formationComponent.service';
import {JhiAlertComponent, Principal} from '../../../shared';
import {Cours} from '../cours.model';
import {Response} from '@angular/http';
import {AlertService} from 'ng-jhipster';

@Component({
    selector: 'jhi-formation-component',
    templateUrl: './formation.component.html'
})

export class FormationComponent implements OnInit {

    @Input() candidatureFormation: CandidatureFormation = {};
    @Input() isEditable: Boolean;
    @Input() isBO: number;
    @Input() questions: Question[];
    @Input() listeCours: Cours[];
    @Output() questionsChange: EventEmitter<Question[]> = new EventEmitter();
    @Output() desCategoriesFormationDisponiblesChange: EventEmitter<boolean> = new EventEmitter();
    @Input() currentLang: string;
    constants = CONSTANTS;
    public categoriesFormation: CategorieFormation[];
    currentAccount: any;
    userEnEchange: UserEnEchange;
    userId: number;

    codesMONO = [
        'Biologie', 'Mathématiques', 'Chimie, physique', 'Sciences de la terre', 'Informatique'
    ];
    private desCategoriesFormationDisponibles: boolean;
    private isLoading: boolean;

    constructor(private categorieFormationService: CategorieFormationService,
                private questionService: QuestionService,
                private reponseService: ReponseService,
                private userEnEchangeService: UserEnEchangeService,
                private principal: Principal,
                private formationComponentService: FormationComponentService,
                private alertService: AlertService
    ) {
        formationComponentService.formationChanged$.subscribe(formationId => {
            this.candidatureFormation.formationId = formationId;
            this.getListeQuestions();
            // this.principal.identity().then(account=> this.userId=account) ;
        });
        formationComponentService.fcChanged$.subscribe(fc => {
            this.candidatureFormation.fc = fc;
            this.getListeQuestions();
            // this.principal.identity().then(account=> this.userId=account) ;
        });
    }

    ngOnInit() {
        // Load la liste des questions complémentaire de la formation et les réponses
        this.getListeQuestions();

        this.userId = this.candidatureFormation.userId;
        // cherche les categories qui sont disponibles pour le candidat selon les critères normal,
        // ou re inscription, ou en echange en international, ou hors echange en international
        let getCategories: Observable<Response>;
        if (this.isEditable == false) {
            getCategories = this.categorieFormationService.queryDisponibles({
                etudiantId: this.candidatureFormation.userId,
                reinscription: this.candidatureFormation.reinscription,
                lecture: (this.isBO > 0 || !this.isEditable)
            });
        } else {
            getCategories = this.categorieFormationService.queryDisponibles({
                etudiantId: this.candidatureFormation.userId,
                reinscription: this.candidatureFormation.reinscription,
                ei: this.candidatureFormation.ei,
                lecture: (this.isBO > 0 || !this.isEditable)
            });
        }
        // determine si l'utilisateur courant est en echange
        let getUserEchange = this.userEnEchangeService.findByCadensUserId(this.userId);

         Observable.forkJoin([getCategories, getUserEchange]).subscribe(results => {
            this.categoriesFormation = results[0].json();
            this.userEnEchange = results[1];
             let categorieFormationFound = true;
             if (this.categoriesFormation.length > 0) {
                 if (this.categoriesFormation.every(categorie => categorie.disabled == true)) {
                     if (this.isEditable == true) {
                         this.isEditable = false;
                         categorieFormationFound = false;
                     }
                }
             } else {
                 categorieFormationFound = false;
             }
             this.desCategoriesFormationDisponibles = categorieFormationFound;
             this.desCategoriesFormationDisponiblesChange.emit(categorieFormationFound);

        });
    }

    isCategorieDisplayed(catCode: String): Boolean {
        let displayed: Boolean = false;
        if (this.categoriesFormation) {
            let cat = this.categoriesFormation.find(categ => categ.code == catCode);
            if (cat) {
                displayed = cat.displayed;
            }
        }
        return (displayed);
    }

    chooseFormation(categorieFormation) {
        if (this.isEditable) {
            if (this.candidatureFormation.categorieFormation !== categorieFormation) {
                this.candidatureFormation.categorieFormation = categorieFormation;
                this.candidatureFormation.categorieFormationId = this.categoriesFormation.find(f => f.code == categorieFormation).id;
                this.candidatureFormation.mentionId = null;
                this.candidatureFormation.parcoursId = null;
                this.candidatureFormation.discipline = null;
                this.candidatureFormation.niveauId = null;
                this.candidatureFormation.disciplineId = null;
                this.candidatureFormation.formationId = null;
                this.candidatureFormation.ects = null;
                this.candidatureFormation.libelle = null;
                this.candidatureFormation.fc = null;
                this.questions = [];
            }
        }
    }

    private getListeQuestions() {
        if (this.candidatureFormation.formationId != null) {
            let queries: Observable<Response> [] = [];
            let categorieIdList: Number[] = [];
            categorieIdList.push(CategorieFormation.CategorieFormationIds.GENERAL);
            categorieIdList.push(this.candidatureFormation.categorieFormationId);
            if (this.candidatureFormation.fc === true) {
                categorieIdList.push(CategorieFormation.CategorieFormationIds.FC);
            }
            let getQuestions = this.questionService.query({
                interne : this.candidatureFormation.reinscription,
                formationId: this.candidatureFormation.formationId,
                categorieIdList: categorieIdList
            });
            queries.push(getQuestions);

            let getReponses = this.reponseService.query({
                candidatureFormationId: this.candidatureFormation.id
            });
            queries.push(getReponses);
            let getQuestionsFc = null;

            this.isLoading = true;
            Observable.forkJoin(queries).subscribe(results => {
                this.questions = results[0].json();
                let reponses: Reponse[] = results[1] != null ? results[1].json() : [];
                this.questions.forEach(question => {
                    question.candidatureFormationId = this.candidatureFormation.id;
                    let rep = reponses.find(r => question.id === r.question.id);
                    if (rep) {
                        question.reponse = rep.response;
                    }
                });
                this.questionsChange.emit(this.questions);
                this.isLoading = false;
            }, error => {
                this.onError(error);
            });
        }
    }

    onError(response: Response) {
        this.isLoading = false;
        JhiAlertComponent.onError(this.alertService, response);
    }

    // Sur reception de l'evenement, click sur le bouton autres formations
    // noinspection JSMethodCanBeStatic
    btnActivation(activationType) {
        if (activationType != null && activationType.value.btnAction === 'AutreFormation') {
            let button = document.getElementById('AUTRES');
            if (button != null) {
                button.click();
            }
        }
    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/formation/formation.component.ts